import React, { FC } from 'react'
import CloseIcon from '../../../../static/steam-img/Close.svg'
import { CustomBackdrop, CustomBackdropDotted, ModalOuter } from './style'

//* Components
import Fade from '@material-ui/core/Fade'
import Modal from '@material-ui/core/Modal'
import WrapperImage from '../wrapperImage'

type Props = {
  modalTitle: string
  modalDescription: string
  open: boolean
  handleClose: any
  innerClasses?: string
  modalHeading?: string
  children: any
  testId?: string
  dotted?: boolean
  contentType?: string
}

const wwwModal: FC<Props> = ({
  modalTitle,
  modalDescription,
  open,
  handleClose,
  innerClasses,
  modalHeading,
  children,
  testId,
  dotted,
  contentType,
}) => {
  const handleXClick = (e: any) => {
    e.preventDefault()
    handleClose()
  }

  return (
    // @ts-ignore
    <Modal
      aria-labelledby={modalTitle}
      aria-describedby={modalDescription}
      open={open}
      onClose={handleClose}
      closeAfterTransition
      slots={{ backdrop: dotted ? CustomBackdropDotted : CustomBackdrop }}
      slotProps={{
        backdrop: {
          timeout: 250,
        },
      }}
      data-cy={testId}
      className={contentType === 'speakerText' ? 'scroll' : 'visible'}>
      <Fade in={open}>
        <ModalOuter className={`CustomerPortalModal ${innerClasses}`} $contentType={contentType}>
          <div className="Modal-Title-Container">
            <h3 className="Modal-Title Regular">{modalHeading}</h3>
            <a href="#" onClick={handleXClick}>
              <WrapperImage
                src={CloseIcon}
                alt="Close Icon"
                className="Modal-Close-Icon"
                threshold={650}
              />
            </a>
          </div>
          {children}
        </ModalOuter>
      </Fade>
    </Modal>
  )
}

export default wwwModal
